import { observer } from "mobx-react-lite";
import { useState } from "react";

import { count } from "../../count";
import { useStores } from "../../stores/useStores";
import { Button, IconButton } from "../ui/controls";
import { Icon } from "../ui/Icon";
import { Empty, List, PaneHeader, PaneTitle, Row, RowDetail, RowText, RowTitle } from "../ui/lists";
import { NewSetlistDialog } from "./NewSetlistDialog";

/** All setlists, the newest first. */
export const SetlistList = observer(function SetlistList({ selectedId }: { selectedId?: string }) {
    const { library, navigation } = useStores();
    const [adding, setAdding] = useState(false);
    const open = (setlistId: string) => navigation.go({ name: "setlists", setlistId });

    return (
        <>
            <PaneHeader>
                <PaneTitle>Setlists</PaneTitle>
                <IconButton aria-label="New setlist" $active onClick={() => setAdding(true)}>
                    <Icon name="plus" />
                </IconButton>
            </PaneHeader>
            {library.setlists.length === 0 ? (
                <Empty>
                    <span>There are no setlists yet. A setlist holds the songs for one service or rehearsal, in order.</span>
                    <Button $kind="primary" onClick={() => setAdding(true)}>
                        New setlist
                    </Button>
                </Empty>
            ) : (
                <List>
                    {library.setlists.map((setlist) => (
                        <li key={setlist.id}>
                            <Row aria-current={setlist.id === selectedId} onClick={() => open(setlist.id)}>
                                <RowText>
                                    <RowTitle>{setlist.name}</RowTitle>
                                    <RowDetail>{count(setlist.items.length, "song")}</RowDetail>
                                </RowText>
                            </Row>
                        </li>
                    ))}
                </List>
            )}
            {adding && <NewSetlistDialog onClose={() => setAdding(false)} />}
        </>
    );
});
